import { Component, OnInit } from '@angular/core';
import { AwardsService } from '../awards.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayService } from '../../../shared/display.service';
import { CurrencyService } from '../../../shared/currency.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';
import { UrlService } from '../../../shared/url.service';

@Component({
  selector: 'app-awards-country-bandgroup',
  templateUrl: './awards-country-bandgroup.component.html',
  styleUrls: ['./awards-country-bandgroup.component.scss']
})
export class AwardsCountryBandgroupComponent implements OnInit {

  awardsCountryBandGroupData: any;
  dtOptions: DataTables.Settings = {};

  constructor(
    private awardsService: AwardsService,
    private route: ActivatedRoute,
    public displayService: DisplayService,
    private router: Router,
    public analyticsService: AnalyticsService,
    public currencyService: CurrencyService,
    public urlService: UrlService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.dtOptions = {
      "lengthChange": false,
      "searching": false,
      "paging": false,
      "info": false,
      "columnDefs": [
        { "orderable": false, "targets": 1 },
        { "orderable": false, "targets": 7 },
      ]
    };
    this.route.params.subscribe(p => {
      this.awardsService.getAwardsByCountryBandGroup(p.countryCode, p.bandGroup)
        .subscribe(data => {
          this.awardsCountryBandGroupData = data;
        });
    });
  }

  getDocumentUrl(uniqueNumber: string): string {
    return this.urlService.getClientSiteUrl(uniqueNumber);
  }

  hideStatus(row: any): boolean {
    return !row.status && !row.statusComment;
  }

  isSpectrumLightContent(value: string) {
    if (value === 'BLUR_CONTENT') {
      return '<p class="SpectrumLight">Upgrade...</p>';
    } else {
      return value;
    }
  }

  isSpectrumLightComment(value: string) {
    if (value === 'BLUR_COMMENT') {
      return '';
    } else {
      return value;
    }
  }
}
